import React from "react";
import { motion } from "framer-motion";

export default function About({ content }) {
  const a = content?.about || {};
  const chapters = a.chapters || [];

  return (
    <section id="sobre" data-testid="about-section" className="py-24 md:py-40 bg-peca-surface border-y border-peca-line">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <span className="label-mono text-peca-yellow">✳ {a.eyebrow}</span>
            <h2 className="mt-5 font-display font-extrabold uppercase text-4xl md:text-5xl tracking-tight leading-[0.95] text-peca-cream sticky top-28">
              {a.title}
            </h2>
          </div>

          <div className="md:col-span-8 md:col-start-5">
            <div className="flex flex-col divide-y divide-peca-line">
              {chapters.map((c, i) => (
                <motion.div
                  key={i}
                  data-testid={`about-chapter-${i}`}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                  className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-10 first:pt-0 group"
                >
                  <span className="font-mono-p text-peca-yellow text-lg md:text-2xl">{c.number}</span>
                  <div>
                    <h3 className="font-display font-bold uppercase text-2xl md:text-4xl tracking-tight text-peca-cream mb-4 group-hover:translate-x-2 transition-transform duration-300">
                      {c.title}
                    </h3>
                    <p className="text-peca-grey text-base md:text-lg leading-relaxed max-w-2xl">{c.body}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
